(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["business-purchase-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('business-purchase-fields')) {
    customElements.define(
      'business-purchase-fields',
      class BusinessPurchaseFields extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-business-purchase-toggle]');
          this.details = this.querySelector('[data-business-purchase-details]');
          this.companyId = this.querySelector('[data-business-purchase-id]');

          this.toggle.addEventListener('change', () => this.update());
          this.companyId.addEventListener('change', () => this.save());
          this.update(false);
        }

        update(shouldSave = true) {
          const isChecked = this.toggle.checked;
          this.details.hidden = !isChecked;
          this.toggle.setAttribute('aria-expanded', String(isChecked));
          this.companyId.disabled = !isChecked;
          this.companyId.required = isChecked;

          if (!isChecked) this.companyId.value = '';
          if (shouldSave) this.save();
        }

        save() {
          fetch(window.routes.cart_update_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                'business-purchase': this.toggle.checked ? 'yes' : '',
                'vat-id': this.toggle.checked ? this.companyId.value.trim() : '',
              },
            }),
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
